import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import LabelValueCard from './LabelValueCard';
const RevisionEditCard = ({ item, tsprCspr }) => {

    const timestamp = new Date(item.timestamp);
    const year = timestamp.getFullYear();
    const month = (timestamp.getMonth() + 1).toString().padStart(2, "0");
    const day = timestamp.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    const tslsvCslsvKeyChange = { ...item?.changes };

    if (tslsvCslsvKeyChange?.removal_tslsv !== undefined) {
        tslsvCslsvKeyChange.tspr = tslsvCslsvKeyChange?.removal_tslsv;
        delete tslsvCslsvKeyChange.removal_tslsv;
    }

    if (tslsvCslsvKeyChange?.removal_cslsv !== undefined) {
        tslsvCslsvKeyChange.cspr = tslsvCslsvKeyChange?.removal_cslsv;
        delete tslsvCslsvKeyChange.removal_cslsv;
    }

    return (
        <Fragment>
            <Grid container spacing={3}>
                <LabelValueCard md={6} label='Updated at' value={formattedDate} />
                <LabelValueCard md={6} label='Updated by' value={item.user && item.user.name ? item.user.name : '--'} />
            </Grid>
            <div className="edit-detail-table">
                <table>
                    <thead>
                        <tr>
                            <th style={{ width: '33%' }}>Label</th>
                            <th style={{ width: '33%' }}>Old Value</th>
                            <th style={{ width: '33%' }}>New Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(tsprCspr ? tslsvCslsvKeyChange : item?.changes).map(label =>
                            <tr>
                                <td style={{ textTransform: 'capitalize' }}>{label.trim().includes('_') ? label.trim().replace(/[_]/g, ' ') : label}</td>
                                <td>{tsprCspr ? tslsvCslsvKeyChange[label][0] : item?.changes[label][0]}</td>
                                <td>{tsprCspr ? tslsvCslsvKeyChange[label][1] : item?.changes[label][1]}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}
export default RevisionEditCard;
